module.exports = __webpack_public_path__ + "7e015846f6d634e4fb7b35eefd512f7a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/beak/bunny-beak-s.png
// module id = 1813
// module chunks = 0